<template>
  <div>
    <h1 class="py-3">
      {{ $t("company.geographically.catalogue.page.title") }}
    </h1>

    <v-divider></v-divider>
    <v-tabs v-model="current_tab" color="background">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab ripple href="#available" class="secondary--text px-3"
        >{{ $t("company.geographically.catalogue.page.tabs.available.tab") }}
        <v-chip v-if="catalogue" small color="success" class="ml-2">{{
          catalogue.geo_availability_overview.geo_allowed
        }}</v-chip>
      </v-tab>
      <v-tab ripple href="#blocked" class="secondary--text px-3"
        >{{ $t("company.geographically.catalogue.page.tabs.blocked.tab") }}
        <v-chip v-if="catalogue" small color="error" class="ml-2">{{
          catalogue.geo_availability_overview.geo_blocked
        }}</v-chip>
      </v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <v-card v-if="catalogue" class="text-xs-center py-3 transparent">
      <v-layout row wrap>
        <!-- Total -->
        <v-flex xs4>
          <div>
            <div class="secondary--text display-2">
              {{ catalogue.geo_availability_overview.total_events }}
            </div>
            <div class="subheading secondary--text font-weight-thin">
              {{
                $t(
                  "company.geographically.catalogue.page.tabs.overview.total_vod"
                )
              }}
            </div>
          </div>
        </v-flex>
        <!--Imported -->
        <v-divider vertical></v-divider>
        <v-flex xs4>
          <div>
            <div class="secondary--text display-2">
              {{ catalogue.geo_availability_overview.geo_allowed }}
            </div>
            <div class="subheading secondary--text font-weight-thin">
              {{
                $t(
                  "company.geographically.catalogue.page.tabs.overview.available"
                )
              }}
            </div>
          </div>
        </v-flex>

        <v-divider vertical></v-divider>
        <v-flex xs3>
          <div>
            <div class="secondary--text display-2">
              {{ catalogue.geo_availability_overview.geo_blocked }}
            </div>
            <div class="subheading secondary--text font-weight-thin">
              {{
                $t(
                  "company.geographically.catalogue.page.tabs.overview.blocked"
                )
              }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card v-if="isLoading" class="transparent" height="10vh">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12>
            <v-progress-circular
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-card v-if="catalogue" class="transparent pt-4">
        <v-divider></v-divider>
        <v-data-table
            :items="vodEvents"
            class="transparent"
            hide-actions
            hide-headers
            >
            <template v-slot:items="props">
                <tr
                :class="[
                    props.index == currentIndex ? 'playing_film' : '',
                    'pointer_cursor',

                ]"
                v-if="props.item"
                >
                <td class="pa-1 pa-0 ma-0 background" width="5%">
                    <v-card class="transparent pa-1">
                        <v-layout row>
                            <v-flex>
                                <template >
                                    <v-img v-if="props.item.thumbnail_url" min-width="60px" slot="activator" :src="props.item.thumbnail_url" contain></v-img>
                                    <v-img v-else-if="props.item.films[0] && props.item.films[0].thumburls" min-width="60px" slot="activator" :src="props.item.films[0].thumburls" contain></v-img>
                                </template>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </td>
                <td class="background" width="95%">
                    <div>
                        <h2>{{props.item.title}}</h2>
                    </div>
                </td>
                </tr>
            </template>
            <template v-slot:no-data>
                <v-layout row wrap justify-center text-xs-center class="pa-5">
                <v-flex xs12 class="py-2 title secondary--text">
                    {{ $t("screener.consumer.no_screenings") }}
                </v-flex>
                <v-flex xs12 class="py-2">
                    <router-link
                    class="secondary--text subheading"
                    :to="{ name: 'screeners.upcoming' }"
                    >{{ $t("screener.browse_screenings.title") }}</router-link
                    >
                </v-flex>
                </v-layout>
            </template>
            </v-data-table>
    </v-card>
    <div v-if="catalogue" class="text-xs-center mb-4">
        <v-pagination
          v-model="page"
          :length="catalogue.screeners.last_page"
          :total-visible="7"
        ></v-pagination>
      </div>
  </div>
</template>
<script>
import i18n from "@/i18n";
export default {
  name: "GeoGraphicalCatalogue",
  data() {
    return {
      catalogue: null,
      page: 1,
      perPage: 10,
      search: "",
      active: null,
      current_tab: "available",
      company: null,
      members: null,
      mailchimpLists: [],
      isLoading: false,
      tabs: [
        {
          text: i18n.t(
            "company.geographically.catalogue.page.tabs.available.tab"
          ),
          href: "#available",
        },
        {
          text: i18n.t(
            "company.geographically.catalogue.page.tabs.blocked.tab"
          ),
          href: "#blocked",
        },
      ],
    };
  },
  mounted() {
    this.getGeoGraphicalCatalogue(this.current_tab);
  },
  computed: {
    vodEvents() {
        if(!this.catalogue.screeners.data){
            return []
        }

        return Object.values(this.catalogue.screeners.data)
    }
  },

  watch: {
    current_tab: {
      handler(newValue, oldValue) {
        this.getGeoGraphicalCatalogue(newValue);
      },
    },
    page: {
        handler: 'getGeoGraphicalCatalogue'
    }
  },

  methods: {
    getGeoGraphicalCatalogue(geoAvailability) {
      this.isLoading = true;
      this.$store
        .dispatch("screening/getGeoGraphicalCatalogue", {
          screenerType: "vod",
          geoAvailability,
          page: this.page,
          perPage: this.perPage,
          search: this.search,
        })
        .then((response) => {
          this.catalogue = response;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
